import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';


const defaultToolbarStyles = {
    iconButton: {
    },
};


class ActivityFeatureAdd extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        this.state = {

            open: false,
            setOpen: false,
            jotainMuuttui: false,

            //openAddressSearch: false,
            ActivityFeatureId: null,
            Activity_Id: null,
            ContentType: null,
            VideoLength: null,
            PublishWeekDay: null,
            PublishTimeOfDay: null,
            NumOfFemale: null,
            NumOfMale: null,
            NumOfAnimal: null,
            Location: null,
            HasText: null,
            HasMusic: null,
            Setup: null,
            BaseOnTrend: null,
            NumOfHastags: null,
            NumOfTags: null,
            BrandShowLengthSec: null,
            BrandShowPosition: null,
            IsPitching: null,
            IsStrongCTA: null,
            IsGeneralInsight: null,
            Modifier: null,
            StartTime: null,
            EndTime: null,
            activity: (Object.keys(props.lookupLists.activity).map((d) => ({ value: d, label: props.lookupLists.activity[d] })) || []),
            
        };
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            //openAddressSearch: false,
            ActivityFeatureId: null,
            Activity_Id: null,
            ContentType: null,
            VideoLength: null,
            PublishWeekDay: null,
            PublishTimeOfDay: null,
            NumOfFemale: null,
            NumOfMale: null,
            NumOfAnimal: null,
            Location: null,
            HasText: null,
            HasMusic: null,
            Setup: null,
            BaseOnTrend: null,
            NumOfHastags: null,
            NumOfTags: null,
            BrandShowLengthSec: null,
            BrandShowPosition: null,
            IsPitching: null,
            IsStrongCTA: null,
            IsGeneralInsight: null,
            Modifier: null,
            StartTime: null,
            EndTime: null
        });
    }

    handleSave = () => {
        this.props.onAddNewRow({
            ActivityFeatureId: 1,
            Activity_Id: this.state.Activity_Id,
            ContentType: this.state.ContentType,
            VideoLength: this.state.VideoLength,
            PublishWeekDay: this.state.PublishWeekDay,
            PublishTimeOfDay: this.state.PublishTimeOfDay,
            NumOfFemale: this.state.NumOfFemale,
            NumOfMale: this.state.NumOfMale,
            NumOfAnimal: this.state.NumOfAnimal,
            Location: this.state.Location,
            HasText: this.state.HasText,
            HasMusic: this.state.HasMusic,
            Setup: this.state.Setup,
            BaseOnTrend: this.state.BaseOnTrend,
            NumOfHastags: this.state.NumOfHastags,
            NumOfTags: this.state.NumOfTags,
            BrandShowLengthSec: this.state.BrandShowLengthSec,
            BrandShowPosition: this.state.BrandShowPosition,
            IsPitching: this.state.IsPitching,
            IsStrongCTA: this.state.IsStrongCTA,
            IsGeneralInsight: this.state.IsGeneralInsight,
            Modifier: this.state.Modifier,
            StartTime: this.state.StartTime,
            EndTime: this.state.EndTime
        });

        this.handleClearData();
    };

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true });
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, activity } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.NewRow}>
                    <IconButton onClick={this.handleClickOpen}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.ActivityFeature.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>

                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Activity_Id')}
                                options={activity}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.ActivityFeature.Columns[1]} />}
                            />
                        </Box>
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.ContentType}
                            onChange={this.handleChange('ContentType')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[3]}
                            type="text"
                            fullWidth
                            value={this.state.VideoLength}
                            onChange={this.handleChange('VideoLength')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[4]}
                            type="text"
                            fullWidth
                            value={this.state.PublishWeekDay}
                            onChange={this.handleChange('PublishWeekDay')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[5]}
                            type="text"
                            fullWidth
                            value={this.state.PublishTimeOfDay}
                            onChange={this.handleChange('PublishTimeOfDay')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[6]}
                            type="text"
                            fullWidth
                            value={this.state.NumOfFemale}
                            onChange={this.handleChange('NumOfFemale')}
                        />

                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[7]}
                            type="text"
                            fullWidth
                            value={this.state.NumOfMale}
                            onChange={this.handleChange('NumOfMale')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[8]}
                            type="text"
                            fullWidth
                            value={this.state.NumOfAnimal}
                            onChange={this.handleChange('NumOfAnimal')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[9]}
                            type="text"
                            fullWidth
                            value={this.state.Location}
                            onChange={this.handleChange('Location')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[10]}
                            type="text"
                            fullWidth
                            value={this.state.HasText}
                            onChange={this.handleChange('HasText')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[11]}
                            type="text"
                            fullWidth
                            value={this.state.HasMusic}
                            onChange={this.handleChange('HasMusic')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[12]}
                            type="text"
                            fullWidth
                            value={this.state.Setup}
                            onChange={this.handleChange('Setup')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[13]}
                            type="text"
                            fullWidth
                            value={this.state.BaseOnTrend}
                            onChange={this.handleChange('BaseOnTrend')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[14]}
                            type="text"
                            fullWidth
                            value={this.state.NumOfHastags}
                            onChange={this.handleChange('NumOfHastags')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[15]}
                            type="text"
                            fullWidth
                            value={this.state.NumOfTags}
                            onChange={this.handleChange('NumOfTags')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[16]}
                            type="text"
                            fullWidth
                            value={this.state.BrandShowLengthSec}
                            onChange={this.handleChange('BrandShowLengthSec')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[17]}
                            type="text"
                            fullWidth
                            value={this.state.BrandShowPosition}
                            onChange={this.handleChange('BrandShowPosition')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[18]}
                            type="text"
                            fullWidth
                            value={this.state.IsPitching}
                            onChange={this.handleChange('IsPitching')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[19]}
                            type="text"
                            fullWidth
                            value={this.state.IsStrongCTA}
                            onChange={this.handleChange('IsStrongCTA')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.ActivityFeature.Columns[20]}
                            type="text"
                            fullWidth
                            value={this.state.IsGeneralInsight}
                            onChange={this.handleChange('IsGeneralInsight')}
                        />
                        
                        
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles (defaultToolbarStyles, { name: "ActivityFeatureAdd" }) (ActivityFeatureAdd);
